class AppError {
	constructor(error: unknown, component?: string) {
		return { component, error: error instanceof Error ? error : new Error(String(error)) };
	}
}

export default AppError;
